jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($(".hero-regular .play-youtube").length) {
    var smcontroller = new ScrollMagic.Controller();

    /************************************************************************
     ***  <header class="hero-regular"> Play Youtube Video functionality  ***
     *************************************************************************/
    $(".hero-regular .play-youtube").click(function (event) {
      var $iframe = $(".youtube-player iframe"),
        video = $($iframe).attr("src");

      if (video.includes("youtube")) {
        setTimeout(function () {
          video = video.replace("?autoplay=0", "?autoplay=1");
          $($iframe).attr("src", video);
        }, 400);
      }

      $(".hero-regular>.container").addClass("playing-yt");
    });
    $(".youtube-player .close").click(function (event) {
      var $iframe = $(".youtube-player iframe"),
        video = $($iframe).attr("src");

      if (video.includes("youtube")) {
        video = video.replace("?autoplay=1", "?autoplay=0");
        $($iframe).attr("src", "");
        $($iframe).attr("src", video);
      }

      $(".hero-regular>.container").removeClass("playing-yt");
    });
    /****************************************************************************
     ***  END <header class="hero-regular"> Play Youtube Video functionality  ***
     *****************************************************************************/
  }
});

/** Not working **/
/*
setTimeout( function () {
  var $productsNav = $( ".basic-slider .owl-carousel" );
  $productsNav.owlCarousel( {
    nav: false,
    rewind: true,
    center: true,
    rewindSpeed: 0,
    dots: true,
    lazyLoad: true,
    autoWidth: true,
    onInitialized: fixAutowidth,
    responsive: {
      950: {
        loop: true,
        nav: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="translate(-6 -5.379)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M107.824 18H7.5" transform="translate(0 12.95)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M30.95 54.4L7.5 30.95 30.95 7.5"/></g></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="rotate(180 50.912 24.51)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M100.324 0H0" transform="translate(0 23.45)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M23.45 46.9L0 23.45 23.45 0"/></g></svg>'
        ]
      }
    }
  } );

  function fixAutowidth( event ) {
    var $theSlider = event.target,
      $theStage = $( $theSlider )
      .children()
      .children( ".owl-stage" ),
      stageWidth = $( $theStage ).width() + event.item.count;

    setTimeout( function () {
      $( $theStage ).css( "width", stageWidth + "px" );
    }, 0 );
  }
}, 0 );
 */
